import tw from 'twin.macro'

export const modalBackdropCss = tw`fixed inset-0 z-[9000] bg-[rgba(0,0,0,0.22)] backdrop-blur-[4px]`

export const modalCardCss = tw`fixed left-1/2 top-1/2 z-[9001] flex max-h-[80vh] w-[520px] -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden rounded-2xl bg-shades-0 shadow-[0_20px_60px_rgba(0,0,0,0.18)]`

export const modalHeaderCss = tw`flex flex-shrink-0 items-center justify-between border-b border-shades-100 px-6 py-[18px] border-solid`

export const modalTitleCss = tw`text-[17px] font-bold text-shades-900`

export const modalCloseBtnCss = tw`flex h-7 w-7 flex-shrink-0 cursor-pointer items-center justify-center rounded-lg border-0 bg-shades-100 text-shades-500 hover:bg-shades-200 border-solid`

export const modalBodyCss = tw`flex flex-col gap-5 overflow-y-auto px-6 py-4`

export const modalFooterCss = tw`flex flex-shrink-0 items-center justify-between border-t border-shades-100 px-6 py-4 border-solid`

export const modalFooterHintCss = tw`text-[13px] text-shades-500`

export const modalFooterActionsCss = tw`flex gap-2`

export const modalCategoryLabelCss = tw`mb-2 text-[11px] font-semibold uppercase tracking-wider text-shades-400`

export const stepChipCss = (blocked: boolean, selected: boolean) => [
  tw`inline-flex h-[30px] items-center gap-1.5 rounded-lg border border-solid box-border shadow-none px-3 text-[13px] font-medium leading-none`,
  blocked
    ? tw`cursor-not-allowed border-shades-200 bg-shades-50 text-shades-400`
    : selected
    ? tw`cursor-pointer border-primary-500 bg-primary-100 font-semibold text-primary-700`
    : tw`cursor-pointer border-shades-200 bg-shades-0 text-shades-800 hover:border-primary-300 hover:bg-shades-50`,
]

export const stepMultiChipCss = tw`inline-flex items-center overflow-hidden rounded-lg border border-solid border-primary-500 bg-primary-100 leading-none shadow-none`

export const stepMultiChipBtnCss = tw`flex h-[30px] w-[34px] flex-shrink-0 cursor-pointer items-center justify-center border-0 bg-transparent text-primary-700 hover:bg-primary-200 border-solid`

export const unsavedModalCardCss = tw`fixed left-1/2 top-1/2 z-[9001] w-[400px] -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-2xl bg-shades-0 shadow-[0_20px_60px_rgba(0,0,0,0.18)]`

export const formItemModalCardCss = tw`fixed left-1/2 top-1/2 z-[9001] flex max-h-[80vh] w-[900px] max-w-[calc(100vw-48px)] -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden rounded-2xl bg-shades-0 shadow-[0_20px_60px_rgba(0,0,0,0.18)]`

export const saveConfirmModalCardCss = tw`fixed left-1/2 top-1/2 z-[9001] flex max-h-[85vh] w-[760px] max-w-[calc(100vw_-_48px)] -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden rounded-2xl bg-shades-0 shadow-[0_20px_60px_rgba(0,0,0,0.18)]`

export const formItemTileCss = (selected: boolean) => [
  tw`flex cursor-pointer flex-col gap-2 rounded-[10px] border border-solid box-border shadow-none p-3.5 transition-colors`,
  selected
    ? tw`border-2 border-primary-500 bg-primary-50 border-solid`
    : tw`border-shades-100 bg-shades-0 hover:border-primary-200 hover:bg-shades-50`,
]
